export const floatingActions = {
	massEdit: "Edição em massa de produtos",
	editExcel: "Edição via Excel",
	testFiscal: "Testar integração fiscal",
	testFiscalData: "Testar dados fiscais",
	syncWithDelivery: "Sincronizar com delivery",
	deleteSelected: "Excluir produtos selecionados",
	activateSelected: "Ativar produtos selecionados",
	deactivateSelected: "Desativar produtos selecionados",
	selectedProduct: "Produto selecionado",
	selectedProducts: "Produtos selecionados",
};
